import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		HttpClientModule
	]
})
export class CoreModule { }


// TODO - what is the purpose of this module? It only imports angular modules.
